import React, { useEffect, useState } from "react";
// import AddOfferModal from "./addOfferModal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Container,
  Divider,
  Fab,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
// import { GetAllOffersApi } from "./GetAllOffersApi";
// import UpdateOfferModal from "./updateOfferModal";
import PluseIconn from "../../assets/img/icons/plus_icon.png";
// import { AddOffers } from "./addOffers";
import UpdateOffers from "./updateOffers";
import { GetAllOffersApi } from "../offers/GetAllOffersApi";
import AddOffers from "./addOffers";
import { GetAllOffersByAdmin } from "./companyLoginApiHandler";
export const Offers = () => {
  const [open, setOpen] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [data, setData] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenUpdateModal = (offer = null) => {
    setSelectedOffer(offer);
    setOpenUpdateModal(true);
  };
  const handleCloseUpdateModal = () => {
    setSelectedOffer(null);
    setOpenUpdateModal(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0"); // Get day and add leading zero if needed
    const month = date.toLocaleString("default", { month: "short" }); // Get short month name (e.g., Sep)
    const year = date.getFullYear(); // Get full year (e.g., 2024)

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchAllOffers = async () => {
      try {
        let res = await GetAllOffersByAdmin();
        console.log(res?.data.data.list, "resss");
        setData(res?.data.data.list);
      } catch (error) {
        console.error("Failed to fetch states:", error);
      }
    };

    fetchAllOffers();
  }, [open, openUpdateModal]);

  return (
    <>
      <Grid
        container
        sx={{
          py: 3,
          px: 3,
          paddingTop: "15px",
          backgroundColor: "#E9E9FF",
          minHeight: "100vh",
        }}
      >
        <Grid
          item
          xs={12}
          md={10}
          sm={9}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography variant="h6" sx={{ paddingLeft: "10px" }}>
            Offers
          </Typography>
        </Grid>
        <Grid
          item
          md={2}
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // paddingRight: "30px",
          }}
        >
          <Button
            onClick={() => setOpen(true)}
            variant="contained"
            fullWidth
            sx={{
              bgcolor: "#010093",
              fontWeight: 600,
              fontSize: "13px",
              display: "flex",
              height: "40px",
              alignItems: "center",
              gap: 2,
              marginBottom: "10px",
            }}
          >
            Add Offer
            <img
              src={PluseIconn}
              alt="plus"
              style={{ width: 18, height: 18 }}
            />
          </Button>
        </Grid>
        <Grid
          item
          xs={12}
          mt={2}
          sx={{
            padding: "20px 10px",
            paddingTop: "30px",
            backgroundColor: "#fff",
            borderRadius: "10px",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sx={{
                height: "81vh",
                overflow: "auto",
                paddingX: "20px",
              }}
            >
              <Grid container spacing={1}>
                {data.map((item) => (
                  <Grid key={item.id} item lg={3} sm={6} md={4} xs={12}>
                    <Card
                      sx={{
                        backgroundColor: "#E9E9FF",
                        pt: "0px",
                        border: "2px solid #01008B",
                        p: 1.5,
                      }}
                    >
                      <CardContent sx={{ p: 0 }}>
                        <Stack>
                          <Typography
                            gutterBottom
                            variant="body2"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: 13,
                              }}
                            >
                              Start Date
                            </Typography>{" "}
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#01008B",
                                fontWeight: 500,
                                fontSize: 13,
                              }}
                            >
                              {formatDate(item.fromDate)}
                            </Typography>{" "}
                          </Typography>
                          <Typography
                            gutterBottom
                            variant="body2"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: 13,
                              }}
                            >
                              End Date
                            </Typography>{" "}
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#01008B",
                                fontWeight: 500,
                                fontSize: 13,
                              }}
                            >
                              {formatDate(item.toDate)}
                            </Typography>{" "}
                          </Typography>
                          <Typography
                            gutterBottom
                            variant="body2"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: 13,
                              }}
                            >
                              Status
                            </Typography>{" "}
                            <Typography
                              variant="body2"
                              component="span"
                              sx={{
                                color: "#01008B",
                                fontWeight: 500,
                                fontSize: 13,
                              }}
                            >
                              {item.status}
                            </Typography>{" "}
                          </Typography>
                        </Stack>
                      </CardContent>
                      <CardHeader
                        sx={{ px: 1, pt: "4px" }}
                        action={
                          <Button
                            onClick={() => handleOpenUpdateModal(item)}
                            endIcon={<EditIcon />}
                            variant="contained"
                            sx={{
                              backgroundColor: "#01008B",
                              color: "white",
                              textTransform: "none", // keep 'Edit' as-is
                              fontWeight: 500,
                              "&:hover": {
                                backgroundColor: "#01008B",
                              },
                            }}
                          >
                            Edit
                          </Button>
                        }
                      />
                      <Divider></Divider>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 400,
                          py: 1,
                          textAlign: "left",
                          color: "#01008B",
                        }}
                      >
                        {item.offerInformation}
                      </Typography>
                      <CardMedia sx={{ height: 200 }} image={item.imagePath} />
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <AddOffers open={open} handleClose={handleClose} />
        <UpdateOffers
          open={openUpdateModal}
          handleClose={handleCloseUpdateModal}
          offerData={selectedOffer}
        />
      </Grid>
    </>
  );
};
